export enum UploadUseCase {
    NormalUpload,
    ReplaceMediaContent,
    UploadForSpecificCaseWithExistingMediaView,
  }
  